<template>
  <div>
    <v-row style="margin:2px"> 
        <v-spacer />
        <v-card v-if="step == 1" style="width:90%">
          <v-card-title>
            {{getTitle()}}
          </v-card-title>
          <v-card-text>
            <v-text-field label = "Zadajte e-mail" v-model="email" />
            <p align="center" v-if="feedback" style="color: red">{{feedback}}</p>
            <v-row style="margin:2px">
              <v-spacer />
              <v-btn variant="outlined" @click="sendResetMail()">Odoslať e-mail</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card v-if="step == 2" style="width:90%">
        <v-card-title>
          Reset hesla
        </v-card-title>
        <v-card-text>
          <v-row style="margin:2px">
            <p align="center" v-if="feedback" style="color: green">{{feedback}}</p>
          </v-row>
          <v-row style="margin:2px">
            <v-spacer />
            <v-text-field v-model="part1" variant="outlined" style="margin-right:2px" maxlength="3"/>
            <v-text-field v-model="part2" variant="outlined" style="margin-right:2px" maxlength="3"/>            
            <v-text-field v-model="part3" variant="outlined" style="margin-right:2px" maxlength="3"/>
            <v-spacer />
          </v-row>
          <v-row style="margin:2px">
            <v-spacer />
            <v-btn @click="confirmCode()">Potvrď</v-btn>                        
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-if="step == 3" style="width:90%">
        <v-card-title>
          Nové heslo
        </v-card-title>
        <v-card-text>
          <v-row style="margin:2px">
            <v-text-field label="Heslo:" v-model="passw"                  
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                />
          </v-row>
          <v-row style="margin:2px">
            <v-text-field label="Potvrď heslo:" v-model="confpassw"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                />
          </v-row>
          <v-row style="margin:2px">
            <p align="center" v-if="feedback" style="color:red">{{feedback}}</p>
          </v-row>
          <v-row style="margin:2px">
            <v-spacer />
            <v-btn variant="outlined" @click="changePassword()">Zmeň heslo</v-btn>            
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-if="step == 4" style="width:90%">
        <v-card-title>
          Process finished
        </v-card-title>
        <v-card-text>
          <v-row style="margin:2px">
            <p align="center" style="color:green">Proces ukončený.</p>
          </v-row>
          <v-row style="margin:2px">
            <v-spacer />
            <v-btn variant="outlined" @click="goToDashboard()">{{getNextText()}}</v-btn>            
            <v-spacer />
         </v-row>
        </v-card-text>
      </v-card>
      <v-spacer />
    </v-row>
  </div>
</template>

<script>
import axios from '../axios-auth.js'
import configData from '../config.js'


  export default {
    data: function () {
      return {
        email: '',
        step : 1,
        feedback : null,
        command : null,
        part1: '',
        part2: '',
        part3: '',
        token: '',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters'
        },
        show1: false,
        passw: '',
        confpassw: ''

      }
    },
    mounted() {
      this.$store.commit('setFeedback', null)
      this.email = this.eml
    },
    props:['source','eml'],
    methods: {
      sendResetMail() {
        this.feedback = ''
        if (!this.validEmail(this.email)) {
            this.feedback = "Invalid email address."
            return
        }
        if (this.source == 2) {
          if (this.email != this.eml) {
            this.feedback = "This is not email of logged user."
            return
          }
        }

        axios.post('/pwd-change-mail', {mail: this.email, client_secret: configData.client_secret}, this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.message == 'OK') {
              this.step = 2
              this.feedback = 'Skontrolujte si mailbox a potvrďte zmenu hesla (kontrolujte aj spam folder).'
            } else {
              this.feedback = res.data.description
            }
          })
          .catch(error => {
            this.feedback = error.message
          })

      },
      validEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email);
        },
      confirmCode() {
        this.feedback = ''
        const data = {email: this.email, client_secret: configData.client_secret, code: this.part1 +'-'+ this.part2 + '-' +this.part3}
        axios.post('/pwd-confirm-code', data, this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.message == 'OK') {
              this.token = res.data.token
              this.step = 3
            } else {
              this.feedback = res.data.description
            }
          })
          .catch(error => {
            this.feedback = error.message
          })
      },
      changePassword() {
        this.feedback = ''
        if (this.passw != this.confpassw) {
          this.feedback = "Heslo a jeho potvrdenie musia byť totožné."
          return
        }  
        axios.post('/pwd-change-pwd', {email: this.email, 
                                client_secret: configData.client_secret, 
                                code: this.token,
                                passwd: this.passw}, 
                                this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.message == 'OK') {
              this.token = res.data.token
              this.step = 4
            } else {
              this.feedback = res.data.description
            }
          })
          .catch(error => {
            this.feedback = error.message
          })


      },
      goToDashboard() {
        if (this.source == 1) {
          const data = {
            email: this.email,
            password: this.passw,
            grant_type: "password",
            client_id: 2,
            client_secret: configData.client_secret,
            username: this.email,
          }
          // eslint-disable-next-line no-console           
          // console.log(data)
          this.$store.dispatch('login', data)
          this.$store.dispatch('tryAutologin')
          //this.$router.push({name:'dashboard'})   
        }
        if (this.source == 2) {
          this.$router.push({name:'dashboard'})     
        }
        
      },
      getNextText() {
        if (this.source == 1) {
          return "Vstup do systému!"
        }
        if (this.source == 2) {
          return "Dashboard!"
        }

      },
      getTitle() {
        if (this.source == 1) return "Reset hesla"
        if (this.source == 2) return "Zmena hesla"
      }
    }
  }

</script>
